import { render, staticRenderFns } from "./AddOrEditModal.vue?vue&type=template&id=23e35cbc&scoped=true&"
import script from "./AddOrEditModal.vue?vue&type=script&lang=js&"
export * from "./AddOrEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e35cbc",
  null
  
)

export default component.exports